import { gettext } from '@eb/i18n';
import { UNLIMITED } from './featuresComparison';
import {
    AR_LOCALE,
    AU_LOCALE,
    BE_LOCALE,
    BR_LOCALE,
    CA_LOCALE,
    DE_LOCALE,
    ES_LOCALE,
    FR_CA_LOCALE,
    FR_LOCALE,
    GB_LOCALE,
    HK_LOCALE,
    IE_LOCALE,
    IT_LOCALE,
    NL_LOCALE,
    NZ_LOCALE,
    PT_LOCALE,
    SG_LOCALE,
    US_LOCALE,
} from '@eb/intl';

export const PACKAGE_ONE_FEATURES_A = [
    gettext('One ticket type (ex. "General Admission")'),
    gettext('Ticketing & registration essentials'),
    gettext('Listing on Eventbrite and partner sites'),
    gettext('Online Help Center'),
];

export const PACKAGE_TWO_FEATURES_A = [
    gettext('Everything in Essentials'),
    gettext('Unlimited ticket types'),
    gettext('Ticket sales on your own site'),
    gettext('Customizable checkout forms'),
    gettext('Detailed sales analytics'),
    gettext('Reserved seating'),
    gettext('Chat support'),
];

export const PACKAGE_TWO_FEATURES_A_US = [
    gettext('Everything in Essentials'),
    gettext('Unlimited ticket types'),
    gettext('Ticket sales on your own site'),
    gettext('Customizable checkout forms'),
    gettext('Detailed sales analytics'),
    gettext('Payouts before your event'),
    gettext('Chat support'),
];

export const PACKAGE_TWO_FEATURES_A_MX = [
    gettext('Everything in Essentials'),
    gettext('Unlimited ticket types'),
    gettext('Ticket sales on your own site'),
    gettext('Customizable checkout forms'),
    gettext('Detailed sales analytics'),
    gettext('Reserved seating'),
];

export const PACKAGE_THREE_FEATURES_A = [
    gettext('Everything in Professional'),
    gettext('On-site staffing, support, and rental equipment'),
    gettext('Branded community pages'),
    gettext('Product training'),
    gettext('Online Help Center'),
];

export const PACKAGE_THREE_FEATURES_A_AR_BR = [
    gettext('Everything in Professional'),
    gettext('On-site staffing, support, and rental equipment'),
    gettext('Product training'),
    gettext('Online Help Center'),
];

export const PACKAGE_THREE_FEATURES_A_MX = [
    gettext('Everything in Professional'),
    gettext('Product training'),
];

export const PACKAGE_THREE_FEATURES_A_HK_SG = [
    gettext('Everything in Professional'),
    gettext('Product training'),
    gettext('Online Help Center'),
];

export const CUSTOMER_SUPPORT = {
    title: gettext('Customer Support'),
    perPlanData: [
        gettext('Online help center'),
        gettext('Online help center'),
        gettext('Online help center'),
    ],
};

export const TICKET_TYPES = {
    title: gettext('Ticket types (e.g. "General Admission")'),
    perPlanData: ['1', UNLIMITED, UNLIMITED],
};

export const TR_ESSENTIALS = {
    title: gettext('Ticketing & registration essentials'),
    perPlanData: [true, true, true],
};

export const LISTING_PARTNER_SITES = {
    title: gettext('Listing on Eventbrite and partner sites'),
    perPlanData: [true, true, true],
};

export const TICKET_SALES_SITE = {
    title: gettext('Ticket sales on your own site'),
    perPlanData: [false, true, true],
};

export const CUSTOMIZABLE_CHECKOUT_FORMS = {
    title: gettext('Customizable checkout forms'),
    perPlanData: [false, true, true],
};

export const DETAIL_SALES_ANALYTICS = {
    title: gettext('Detailed sales analytics'),
    perPlanData: [false, true, true],
};

export const PAYOUTS_BEFORE_EVENT = {
    title: gettext('Payouts before your event'),
    perPlanData: [false, true, true],
};

export const ONSITE_RENTAL_SUPPORT = {
    title: gettext('On-site staffing support & rental equipment'),
    perPlanData: [false, false, true],
};

export const BRANDED_PAGES = {
    title: gettext('Branded community pages'),
    perPlanData: [false, false, true],
};

export const COPY_TICKET_DETAILS = {
    title: gettext(
        'Copy ticket settings across multiple ticket types within an event',
    ),
    perPlanData: [false, false, true],
};

export const APPLY_TICKET_TYPES = {
    title: gettext('Save and apply ticket types across multiple events'),
    perPlanData: [false, false, true],
};

export const PREMIUM_TEXT = {
    header: gettext('Do you host large and complex events?'),
    secondaryHeader: gettext('Rely on a proven partner.'),
};

export const ANNUAL_FEE_NONE = gettext('$0');
export const ANNUAL_FEE_CUSTOM = gettext('Custom');

export const ANNUAL_PRICE_PER_LOCALE = {
    [AR_LOCALE]: '$2,995',
    [AU_LOCALE]: 'A$395',
    [BE_LOCALE]: '€395',
    [BR_LOCALE]: 'R$745',
    [DE_LOCALE]: '€395',
    [ES_LOCALE]: '€395',
    [FR_LOCALE]: '€395',
    [GB_LOCALE]: '£250',
    [HK_LOCALE]: '$495',
    [IE_LOCALE]: '€495',
    [IT_LOCALE]: '€395',
    [NL_LOCALE]: '€395',
    [NZ_LOCALE]: 'NZ$395',
    [PT_LOCALE]: '€395',
    [SG_LOCALE]: '$495',
    [US_LOCALE]: '$495',
    [CA_LOCALE]: 'CA$250',
    [FR_CA_LOCALE]: 'CA$250',
};
